import React from 'react';

import classNames from 'classnames';

export interface ICardContentProps {
    children: React.ReactNode;
    className?: string;
}

export const CardContent = (props: ICardContentProps): JSX.Element => {
    const className: string = classNames('card-content', props.className);

    return (
        <div className={className}>
            {props.children}
        </div>
    );
};
